// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"124cc13c","585":"c201251f"}[chunkId] + ".chunk.js";
};